import React from "react";
import Bubbles from "../components/generalComponents/Bubbles";
import NavBar from "../components/navigation/NavBar";
import "./HomeWrap.scss";

const HomeWrap = (Component) =>
  function HOC() {
    return (
      <div className="Home-Wrapper">
        <NavBar />

        <div className="Home-Wrapper__content">
          <div className="Home-Wrapper__content--bubbles">
            <Bubbles />
          </div>
          <div className="Home-Wrapper__content--children">
            <Component />
          </div>
        </div>
      </div>
    );
  };

export default HomeWrap;
